// extracted by mini-css-extract-plugin
module.exports = {"resultCard":"styles__resultCard___tKPJD","discountCard":"styles__discountCard___3Kb9n","name":"styles__name___1y1Aq","status":"styles__status___1T_1J"};